import React from 'react';
import { Switch, Route } from 'react-router';
import { AppRoutes } from '../../routes';
import { DevicesLocationList } from './locations/DevicesLocationList';
import { DevicesOrganizationList } from './organization/DevicesOrganizationList';

export const Devices: React.FC = () => (
    <>
        <Switch>
            <Route path={AppRoutes.DevicesLocation} component={DevicesLocationList} />
            <Route path={AppRoutes.DevicesOrganization} component={DevicesOrganizationList} />
        </Switch>
    </>
);
